import { ComponentProps } from 'react';

export type MarkerIconProps = ComponentProps<'svg'> & {
  isSelected?: boolean;
};

export function MarkerIcon({ isSelected = false, ...props }: MarkerIconProps) {
  return (
    <svg
      display="block"
      height="41px"
      width="27px"
      viewBox="0 0 27 41"
      data-selected={isSelected}
      className="fill-store-primary data-[selected=true]:fill-zmyle-primary transition-colors"
      {...props}
    >
      <g transform="translate(3 29)">
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={10.5}
          ry={5.25002273}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={10.5}
          ry={5.25002273}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={9.5}
          ry={4.77275007}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={8.5}
          ry={4.29549936}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={7.5}
          ry={3.81822308}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={6.5}
          ry={3.34094679}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={5.5}
          ry={2.86367051}
        />
        <ellipse
          opacity={0.04}
          cx={10.5}
          cy={5.80029008}
          rx={4.5}
          ry={2.38636864}
        />
      </g>
      <path d="M27 13.5c0 5.575-6.75 13.5-12.25 21-.733 1-1.767 1-2.5 0C6.75 27 0 19.223 0 13.5 0 6.044 6.044 0 13.5 0S27 6.044 27 13.5z" />
      <path
        d="M13.5 0C6.044 0 0 6.044 0 13.5c0 5.723 6.75 13.5 12.25 21 .75 1.023 1.767 1 2.5 0C20.25 27 27 19.075 27 13.5 27 6.044 20.956 0 13.5 0zm0 1C20.415 1 26 6.585 26 13.5c0 2.399-1.504 5.681-3.78 9.238-2.274 3.557-5.515 7.404-8.277 11.17-.2.273-.33.415-.443.533a4.934 4.934 0 01-.443-.533c-2.773-3.78-5.642-7.594-8.041-11.135C2.616 19.233 1 15.953 1 13.5 1 6.585 6.585 1 13.5 1z"
        opacity={0.25}
      />
      <g transform="translate(8 8)">
        <circle opacity={0.25} cx={5.5} cy={5.5} r={5.4999962} />
        <circle fill="#FFF" cx={5.5} cy={5.5} r={5.4999962} />
      </g>
    </svg>
  );
}
